import React from 'react';
import './Checkbox.scss';

const Checkbox = ({ label, name, checked, onChange, className = '' }) => {
    return (
        <label className={`checkbox-group ${className}`}>
            <input type="checkbox" name={name} checked={checked} onChange={onChange} />
            <span>{label}</span>
        </label>
    );
};

export default Checkbox;